import React from 'react';
import { DisabledPrompt, Link } from "bcms-react";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';

import "./styles.css";

/**
 * @function SecureFormsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for SecureFormsPage
 */
export default function SecureFormsPage(props) {
  return (
    <PageContainer className="secure-forms-page">
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Secure Forms" />
          <div className="flex-container flex-vertical list-group-container">
            <p className="header-text"><b>Address Change</b></p>
            <div className="flex-container flex-horizontal list-row-container">
              <div className="set-width">
                <DisabledPrompt><Link>Address Change</Link></DisabledPrompt>
              </div>
              <div className="flex-width">
                <p>Please fill this form to update your address information. </p>
              </div>
            </div>
          </div>
          {/* <div className="flex-container flex-vertical list-group-container">
            <p className="header-text"><b>Other Forms</b></p>
            <div className="flex-container flex-horizontal list-row-container">
              <div className="set-width">
                <DisabledPrompt><Link>Add Business Functions</Link></DisabledPrompt>
              </div>
            </div>
            <div className="flex-container flex-horizontal list-row-container">
              <div className="set-width">
                <DisabledPrompt><Link>Automatic Transfer Agreement</Link></DisabledPrompt>
              </div>
            </div>
          </div> */}
          {/* <div className="flex-container flex-vertical list-group-container">
            <p className="header-text"><b>Leading Forms</b></p>
            <div className="flex-container flex-horizontal list-row-container">
              <div className="set-width">
                <DisabledPrompt><Link>Loan_form</Link></DisabledPrompt>
              </div>
            </div>
            <div className="flex-container flex-horizontal list-row-container">
              <div className="set-width">
                <DisabledPrompt><Link>Loan Payoff Request</Link></DisabledPrompt>
              </div>
            </div>
          </div> */}
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  )
}
